import { useEffect, useState } from "react";
import { api } from "../lib/api";
import ProductCard from "./ProductCard";

export default function ProductGrid({ compact = false }) {
  const [products, setProducts] = useState([]);
  const [filter, setFilter] = useState("ALL");

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  const cats = ["ALL", ...Array.from(new Set(products.map((p) => p.category)))];
  const shown = filter === "ALL" ? products : products.filter((p) => p.category === filter);

  return (
    <div className={compact ? "" : ""}>
      <div data-testid="shop-filters" className="flex flex-wrap gap-2">
        {cats.map((c) => (
          <button
            key={c}
            data-testid={`filter-${c.toLowerCase().replace(/[\s&]/g, "-")}`}
            onClick={() => setFilter(c)}
            className={`border px-5 py-2 font-tech text-xs tracking-[0.2em] transition-colors duration-200 ${filter === c ? "border-ll-red bg-ll-red text-ll-bone" : "border-ll-bone/25 text-ll-bone/60 hover:border-ll-bone hover:text-ll-bone"}`}
          >
            {c.toUpperCase()}
          </button>
        ))}
      </div>
      <div className="mt-10 grid grid-cols-2 gap-x-4 gap-y-10 md:grid-cols-3 md:gap-x-6">
        {shown.map((p, i) => (
          <ProductCard key={p.slug} product={p} index={i} />
        ))}
      </div>
      {shown.length === 0 && (
        <p data-testid="shop-empty" className="mt-16 text-center font-tech text-sm text-ll-bone/50">Nothing here yet — new pieces land weekly.</p>
      )}
    </div>
  );
}
